import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import classnames from "classnames";

import { useMedia, useNavigate, useUrlParams } from "shared/hooks";
import { UiIcon } from "shared/uikit";
import { ICONS } from "shared/constants";
import { ApplicationModule } from "shared/modules";
import { Storage } from "shared/utilities";

import './index.scss';

const items = [{
    id: 'board',
    icon: (<UiIcon size={24} icon={ICONS.TASK_TRACKER_BOARD}/>)
}, {
    id: 'list',
    icon: (<UiIcon size={24} icon={ICONS.TASK_TRACKER_LIST}/>)
}];
export const CFilterView = observer(() => {
    const navigate = useNavigate();
    const urlParams = useUrlParams({
        view: null as string | null,
        fSortType: null as string | null,
        fSortProperty: null as string | null,
    });

    const { isMobileOrTablet, is1024 } = useMedia();
    const storageKey = `task-tracker:view:${ApplicationModule.user.id}`;
    const selectionVersion = useRef(0);

    useEffect(() => {
        if (isMobileOrTablet || is1024) {
            if (urlParams.view !== null || urlParams.fSortType || urlParams.fSortProperty) {
                navigate(null, {
                    ...urlParams,
                    view: null,
                    fSortType: null,
                    fSortProperty: null,
                }, {}, null);
            }
            return;
        }

        if (urlParams.view === 'list' || urlParams.view === 'board') {
            Storage.set(storageKey, urlParams.view);
            return;
        }

        let active = true;
        const version = selectionVersion.current;
        Storage.get(storageKey, 'board').then(view => {
            if (active && version === selectionVersion.current) {
                navigate(null, {
                    ...urlParams,
                    view: view === 'list' ? 'list' : 'board',
                }, {}, null);
            }
        });
        return () => { active = false; };
    }, [isMobileOrTablet, is1024, navigate, urlParams, storageKey]);

    const handleSelect = (view: string) => {
        selectionVersion.current++;
        Storage.set(storageKey, view);
        navigate(null, {
            ...urlParams,
            view,
            fSortType: null,
            fSortProperty: null,
        });
    }

    return (
        <div className="c-tt-filter-view">
            {items.map(item => (
                <div
                    key={item.id}
                    className={classnames('c-tt-filter-view__item', {
                        'c-tt-filter-view__item--active': urlParams.view === item.id || (item.id === 'board' && urlParams.view === null)
                    })}
                    onClick={() => handleSelect(item.id)}
                >
                    {item.icon}
                </div>
            ))}
        </div>
    )
});
